import { useEffect, useState } from "react";
import { getCountries, checkout } from "../service/api";

function AddressForm({ sku, optionId, optionValue, sizeOptionId, sizeValue, couponCode, onBack, onSuccess, onError }) {

  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [address, setAddress] = useState({
    firstname: "",
    lastname: "",
    email: "",
    telephone: "",
    street1: "",
    street2: "",
    city: "",
    postcode: "",
    region: "",
    region_code: "",
    region_id: 0,
    country_id: "US",
    shipping_method_code: "flatrate",
    shipping_carrier_code: "flatrate"
  });

  const selectedCountry =
    countries.find((c) => c.id === address.country_id) ?? null;

  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    try {
      const res = await getCountries();

      const allowedCountries = ["US"];

    const filtered = res.data.data.filter((c) =>
      allowedCountries.includes(c.id)
    );
      setCountries(filtered);

    } catch (err) {
      console.error("Failed to fetch countries", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setAddress((prev) => {
      const updated = {
        ...prev,
        [name]: value
      };

      if (name === "region_code" && selectedCountry?.available_regions) {

        const region = selectedCountry.available_regions.find(
          (r) => r.code === value
        );

        updated.region_id = region ? parseInt(region.id) : 0;
        updated.region = region ? region.name : "";
      }

      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");

    try {
      await checkout({
        sku,
        qty: 1,
        optionId,
        optionValue,
        sizeOptionId,
        sizeValue,
        couponCode,
        ...address,
        street: [address.street1, address.street2].filter(Boolean)
      });

      onSuccess();
    } catch (err) {
      console.error(err);

      const message =
        err?.response?.data?.error || "Failed to submit order";

      setError(message);

      if (onError) onError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="form-card">

    <form className="address-form" onSubmit={handleSubmit}>

      <h2>Shipping Information</h2>

      <div className="form-row">

        <input
          name="firstname"
          placeholder="First Name"
          value={address.firstname}
          onChange={handleChange}
          required
        />

        <input
          name="lastname"
          placeholder="Last Name"
          value={address.lastname}
          onChange={handleChange}
          required
        />

      </div>

      <input
        name="email"
        type="email"
        placeholder="Email"
        value={address.email}
        onChange={handleChange}
        required
      />

      <input
        name="telephone"
        placeholder="Phone"
        value={address.telephone}
        onChange={handleChange}
        required
      />

      <input
        name="street1"
        placeholder="Address Line 1"
        value={address.street1}
        onChange={handleChange}
        required
      />

      <input
        name="street2"
        placeholder="Address Line 2"
        value={address.street2}
        onChange={handleChange}
      />

      <div className="form-row">

        <input
          name="city"
          placeholder="City"
          value={address.city}
          onChange={handleChange}
          required
        />

        <input
          name="postcode"
          placeholder="Zip Code"
          value={address.postcode}
          onChange={handleChange}
          required
        />

      </div>

        <select
          name="region_code"
          value={address.region_code}
          onChange={handleChange}
        >
          <option value="">Select State</option>

          {selectedCountry?.available_regions?.map((region) => (
            <option key={region.id} value={region.code}>
              {region.name}
            </option>
          ))}

        </select>

        <select
          name="country_id"
          value={address.country_id}
          onChange={handleChange}
          required
        >
          <option value="">Select Country</option>

          {countries.map((country) => (
            <option key={country.id} value={country.id}>
              {country.full_name_english}
            </option>
          ))}

        </select>


      <div className="form-actions">

        <button
          type="button"
          className="secondary-btn"
          onClick={onBack}
        >
          Back to Cart
        </button>

        <button
          type="submit"
          className="primary-btn"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Order"}
        </button>

      </div>

      {error && <p className="error">{error}</p>}

    </form>

  </div>
);
}

export default AddressForm;
